export default __webpack_public_path__ + "static/media/bg_grass_dark.4bcc2369.png";